module.exports = __webpack_public_path__ + "img/DateIcon.c2495e01.svg";